// New component: About.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="max-w-md mx-auto">
        <button 
          onClick={() => navigate('/profile')}
          className="flex items-center text-gray-600 mb-4"
        >
          <span className="ml-2">&lt;</span>
          برگشت
        </button>

        <h2 className="text-2xl font-bold mb-6">درباره ما</h2>

        <p className="text-gray-600">
          
        </p>
      </div>
    </div>
  );
}